<div class="digital-signature-cntr">
  <img alt="homepage" src="assets/companies/AXPOITALIA/logo.png" height="55" />
  <h2 class="title">Firma non completata</h2>
  <p class="description">Qualcosa è andato storto durante il processo. <br>La tua firma non è stata completata correttamente. <br> 
    Per qualsiasi necessità di assistenza, contattaci all'indirizzo mail: <strong>sales.industrial_support.it&#64;axpo.com</strong></p>


</div>

